import setShowListPane from './setShowListPane';
import setShowReadingPane from './setShowReadingPane';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import ReadingPanePosition from 'owa-session-store/lib/store/schema/ReadingPanePosition';
import { action } from 'satcheljs/lib/legacy';

/**
 * Orchestrator for new message for showing list pane and reading pane
 */
export default action('onNewMessage')(function onNewMessage(openInTab: boolean) {
    if (!openInTab) {
        setShowReadingPane(true /* showReadingPane */);
        setShowListPane(
            getUserConfiguration().UserOptions.GlobalReadingPanePositionReact !==
                ReadingPanePosition.Off /* showListPane */
        );
    }
});
